<template>
	<main class="main-wrapper flex-grow-1 bg-documentGray">
 	<TopAppBarLearnListTab :title="$t('30213')"></TopAppBarLearnListTab>
		<!-- 상단 고정 캠페인 배너 -->
	<div class="container container--narrow">
		<div class="mgt-30 mgb-50">
			<div v-if="campaignData && campaignData.locationValue === '0'" class="mgb-30">
				<a v-if="campaignData.dynamicLink" :href="campaignData.dynamicLink.shortLink" class="d-block" target="_blank" >
					<img :alt="campaignData.dynamicLink.name" :src="campaignData.image" class="b-radius4">
				</a>
				<a v-else href="javascript:void(0)" style="cursor:none">
					<img :src="campaignData.image" alt="" class="b-radius4">
				</a>
        	</div>
			<NoData  v-if="isNoData"></NoData>
			<div v-for="(degree, index) in listData" :key="index">
				<!-- 목록 캠페인 카드 -->
				<div v-if="campaignData && parseInt(campaignData.locationValue) === index+1 && $route.query.status !== 'WAITING'" class="mgb-16">
					<a v-if="campaignData.dynamicLink" :href="campaignData.dynamicLink.shortLink" class="d-block" target="_blank">
						<img :src="campaignData.image" class="round">
					</a>
					<a v-else href="javascript:void(0)" style="cursor:none">
						<img :src="campaignData.image" alt="" class="round">
					</a>
				</div>
				<ListItem
					:degree="degree"
					:status="status"
					@initProgressStatus="initProgressStatus"
				></ListItem>
			</div>
			<infinite-loading :identifier="infiniteId"  spinner="spiral" @infinite="fetchData">
				<div slot="no-more" class="mgt-16"></div>
				<div slot="no-results" class="mgt-16"></div>
			</infinite-loading>
		</div>
		</div>
	</main>
</template>

<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
import microLearnApi from '@/api/microLearnApi.js'
import ListItem from './ListItem.vue'
import NoData from '../common/NoDataLearning.vue'
import InfiniteLoading from 'vue-infinite-loading'
import TopAppBarLearnListTab from '../TopAppBarLearnListTab.vue'
import microCampaignApi from "@/api/microCampaignApi";
export default {
	components: {
		ListItem, NoData, InfiniteLoading, TopAppBarLearnListTab
	},

	data() {
		return {
			status: '',
			isNoData: false,
			campaignData: null,
			listData: [],
			currentPage: 1,
			totalPages: 1,
			infiniteId: +new Date(),
			msgData:{
				msg1:this.$t('3206'),
				msg2:this.$t('3207')
			}
		}
	},

	watch:{
		'$route' (to, from){
			this.initData()
		}
	},

	methods: {

		initData() {
			this.listData= []
			this.currentPage = 1
			this.totalPages = 1
			this.infiniteId += 1
		},
		// 목록 데이터 로딩(get list data)
		fetchData($state) {
			let responseData = null
			let params = this.setParams()
			if (this.totalPages >= this.currentPage) {
				microLearnApi.fetchList(params).then((response) => {
					responseData = response.data.data
					// console.log(responseData);
					let contentData = [];
					_.map(responseData.content, (o) => {
						o.progressViewStatus = false;
						if(o.learningStatus.value === "WAITING")
						contentData.push(o)
					})
					if(this.$route.query.status == 'WAITING'){
						this.listData = this.listData.concat(contentData);
					}
					else
					this.listData = this.listData.concat(responseData.content)
					this.currentPage++
					this.totalPages = responseData.totalPages

					if (responseData.content.length) {
						$state.loaded()
					}else {
						$state.complete()
					}
					if (this.listData.length>0) {
						this.isNoData = false
					} else {
						this.isNoData = true
					}

				}).catch((err) => {
					$state.error()
				})

			}else {
				$state.complete()
			}


			// 캠페인 테이터 API 호출(get campaign data)
			// 마이크로 디그리에서는 캠페인은 아직 없음. 추후 생길 예정
			// let locationType = this.$route.query.status === 'LEARNING' ? 'LEARN_IN_PROGRESS_DEGREE' : this.$route.query.status === 'COMPLETION'?'LEARN_COMPLETED_DEGREE':''
			// if(this.$route.query.status === 'LEARNING' || this.$route.query.status === 'COMPLETION') {
      //   microCampaignApi.campaign({locationType: locationType}).then((response) => {
			// 		//console.info(`I am campagion data`, response.data.data)
			// 		this.campaignData = response.data.data
			// 	}).catch((err) => {})
			// } else {
			// 	this.campaignData=''
			// }
		},

		// 파라미터 설정(set parameter)
		setParams() {
			const params = {
				status: this.$route.query.status,
				name: '',
				category: '',
				page: this.currentPage,
				size: 10
			}
			return params
		},

		// 학습진행률 노출 상태 설정(set/toggle learning status graph)
		initProgressStatus(id) {
			_.map(this.listData, (o) => {
				o.id === id && o.progressViewStatus === false ? o.progressViewStatus = true : o.progressViewStatus = false
			})
		}
	}
}
</script>
